/**
 * App root (06 §9 app/) — providers (react-query, router) + the chat shell.
 * Boots the chat store (WS subscription + Dexie hydrate) and theme sync once.
 */
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useChatStore } from '../stores/chatStore';
import { initThemeSync } from '../stores/themeStore';
import { AppShell } from './AppShell';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

export function App() {
  const init = useChatStore((s) => s.init);

  useEffect(() => {
    init();
    initThemeSync();
  }, [init]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/chats" replace />} />
          <Route path="/chats" element={<AppShell />} />
          <Route path="/chats/:chatId" element={<AppShell />} />
          <Route path="*" element={<Navigate to="/chats" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
